import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/sales_order_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  number_cont: {
    model_name: 'SalesOrder',
    column_type: 'string',
    column_name: 'number',
  },
  product_type_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'SalesOrder',
      options: ['custom', 'stock'],
    },
    model_name: 'SalesOrder',
    column_name: 'productType',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'SalesOrder',
      options: ['sample', 'bulk', 'after_sale'],
    },
    model_name: 'SalesOrder',
    column_name: 'kind',
  },
  kind_in: {
    column_type: 'enum',
    extra: {
      model_name: 'SalesOrder',
      options: ['sample', 'bulk', 'after_sale'],
    },
    model_name: 'SalesOrder',
    column_name: 'kind',
  },
  business_kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'SalesOrder',
      options: ['custom', 'wholesale'],
    },
    model_name: 'SalesOrder',
    column_name: 'businessKind',
  },
  customer_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'SalesOrder',
  },
  customer: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'SalesOrder',
  },
  user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'SalesOrder',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'SalesOrder',
  },
  user_team_id_eq: {
    model_name: 'SalesOrder',
    column_type: 'string',
    column_name: 'userTeamIdEq',
  },
  is_transfer_existing_eq: {
    column_type: 'boolean',
    model_name: 'SalesOrder',
    column_name: 'isTransferExisting',
  },
  ordered_on_gteq: {
    column_type: 'date',
    model_name: 'SalesOrder',
    column_name: 'orderedOn',
  },
  ordered_on_lteq: {
    column_type: 'date',
    model_name: 'SalesOrder',
    column_name: 'orderedOn',
  },
  jushuitan_orders_shop_id_eq: {
    column_type: 'belongs_to',
    column_name: 'shop',
    extra: {
      model_name: 'JushuitanShop',
      value_column: 'shop_id',
    },
    model_name: 'JushuitanOrder',
  },
  shop: {
    column_type: 'belongs_to',
    column_name: 'shop',
    extra: {
      model_name: 'JushuitanShop',
      value_column: 'shop_id',
    },
    model_name: 'JushuitanOrder',
  },
  keyword: {
    model_name: 'SalesOrder',
    column_type: 'string',
    column_name: 'number',
  },
  finished_on_not_null: {
    column_type: 'boolean',
    model_name: 'SalesOrder',
    column_name: 'finishedOn',
  },
  finished_on_month_eq: {
    model_name: 'SalesOrder',
    column_type: 'string',
    column_name: 'eXTRACT(YEAR FROM finishedOn) || "-" || LPAD(EXTRACT(MONTH FROM finishedOn)::text, 2, "0")',
  },
  jushuitan_orders_so_id_eq: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'jushuitan_orders',
    extra: {
      model_name: 'JushuitanOrder',
    },
    model_name: 'SalesOrder',
  },
  jushuitan_orders: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'jushuitan_orders',
    extra: {
      model_name: 'JushuitanOrder',
    },
    model_name: 'SalesOrder',
  },
  payment_reminder_due_status_eq: {
    model_name: 'SalesOrder',
    column_type: 'string',
    column_name: 'paymentReminderDueStatusEq',
  },
  jushuitan_orders_o_id_eq: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'jushuitan_orders',
    extra: {
      model_name: 'JushuitanOrder',
    },
    model_name: 'SalesOrder',
  },
}
export const formColumnsConfig = {
  'self': {
    'ordered_on': { required: true, disabledUpdate: false },
    'customer_id': { required: true, disabledUpdate: false },
    'kind': { required: true, disabledUpdate: false },
    'product_type': { required: true, disabledUpdate: false },
    'business_kind': { required: true, disabledUpdate: false },
    'is_transfer_existing': { required: true, disabledUpdate: false },
    'sales_line_items': { required: true, disabledUpdate: false },
    'jushuitan_order_ids': { required: false, disabledUpdate: false },
    'source_id': { required: false, disabledUpdate: false },
    'remark': { required: false, disabledUpdate: false },
    'sales_order_allocations_as_source': { required: false, disabledUpdate: false },
    'after_sale_allocations': { required: false, disabledUpdate: false },
    'payment_reminders': { required: false, disabledUpdate: false },
  },
  'sales_line_items': {
    'id': { required: false, disabledUpdate: true },
    'style_number': { required: true, disabledUpdate: true },
    'price': { required: true, disabledUpdate: true },
    'quantity': { required: true, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
  'sales_order_allocations_as_source': {
    'id': { required: false, disabledUpdate: true },
    'target_id': { required: true, disabledUpdate: true },
    'amount': { required: true, disabledUpdate: true },
    'allocated_on': { required: false, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
  'after_sale_allocations': {
    'id': { required: false, disabledUpdate: true },
    'jushuitan_after_sale_id': { required: true, disabledUpdate: true },
    'received_amount': { required: true, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
  'payment_reminders': {
    'id': { required: false, disabledUpdate: true },
    'stage_index': { required: true, disabledUpdate: true },
    'percentage': { required: true, disabledUpdate: true },
    'amount': { required: true, disabledUpdate: true },
    'date': { required: true, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('SalesOrder', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('SalesOrder', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
